'use client'
import { Link } from 'react-router-dom';
import { WatchListTable } from '@/components/WatchListTable';
import { MostValuableCompanyTable } from '@/components/MostValuableCompanyTable';
import { Power20Table } from '@/components/Power20Table';
import { useState, useEffect, useRef } from 'react';
import type { MostValuableCompany as CompanyType , Power20Company } from '@/types/company';
import {getMostValuableCompanies, getPower20Companies} from '@/api/company';

const watchListTableData = [
  {
    index: 0,
    company: {
      name: 'Anduril',
      image: 'Anduril.png',
      link: ''
    },
    valuation: '$14B',
    price: '$21.74',
    buySell: {
      buy: '$38.00',
      sell: '$26.10'
    }
  }
]

export default function Company() {
  const [mostValuableCompanies, setMostValuableCompanies] = useState<CompanyType[]>([]);
  const [power20Companies, setPower20Companies] = useState<Power20Company[]>([]);
  const [mostValuableCompaniesLoading, setMostValuableCompaniesLoading] = useState(true);
  // const [power20CompaniesLoading, setPower20CompaniesLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const isFirstRender = useRef(true);
  // const isSecondRender = useRef(true);

  // 获取 MostValuableCompanies
  useEffect(() => {
    getAllCompanyList();
    const fetchMostValuableCompanies = async () => {
      if (!isFirstRender.current) return;
      isFirstRender.current = false;

      try {
        setMostValuableCompaniesLoading(true);
        const response = await getMostValuableCompanies('',1,7,'valuation','DESC',[]);
        if (response && 'content' in response && Array.isArray(response.content)) {
          setMostValuableCompanies(response.content);
        } else {
          setError('返回数据格式错误');
          setMostValuableCompanies([]);
        }
      } catch (err) {
        console.error('Error fetching most valuable companies:', err);
        setMostValuableCompanies([]);
      } finally {
        setMostValuableCompaniesLoading(false);
      }
    };

    fetchMostValuableCompanies();
  }, []);

  // 获取 Power20Companies
  // useEffect(() => {
  //   const fetchPower20Companies = async () => {
  //     if (!isSecondRender.current) return;
  //     isSecondRender.current = false;
  //
  //     try {
  //       setPower20CompaniesLoading(true);
  //       const response = await getPower20Companies();
  //       if (Array.isArray(response)) {
  //         setPower20Companies(response);
  //       } else {
  //         console.error('Power20 companies data format error');
  //         setPower20Companies([]);
  //       }
  //     } catch (err) {
  //       console.error('Error fetching power 20 companies:', err);
  //       setPower20Companies([]);
  //     } finally {
  //       setPower20CompaniesLoading(false);
  //     }
  //   };
  //
  //   fetchPower20Companies();
  // }, []);
  const getAllCompanyList = (): void => {
    getPower20Companies().then((res: Power20Company[]) => {
      if(res&&res.length>0){
        setPower20Companies(res);
      }else{
        setPower20Companies([]);
      }
    }).catch((err) => {
      setPower20Companies([]);
      console.error('Error fetching power 20 companies:', err);
    });
  };

  return (
    <div className="">
      <div className="page-content px-4 pb-20 pt-0 sm:pt-0 md:pt-5">
        <div className="power-20-container mb-5 sm:mb-5 md:mb-10">
          <div className="header flex justify-between align-items-center mb-2 sm:mb-2 md:mb-6">
            <div className="font-bold text-xl sm:text-2xl md:text-3xl lg:text-4xl">Power 20</div>
            <div><Link to="/all-companies" className="text-[#40A9FF] header-link hover:text-[#40A9FF] hover:underline text-xs sm:text-sm md:text-base lg:text-lg">View all companies</Link></div>
          </div>
          <div>
            <Power20Table tableData={power20Companies} />
          </div>
          <div className="footer text-sm sm:text-sm md:text-lg">The Power 20 rankings are determined by bids, asks, executed trades reported on the Augment platform, third-party revenue estimates, and other factors. Read full methodology here.</div>
        </div>
        <div className="watch-list-container mb-5 sm:mb-5 md:mb-10">
          <div className="font-bold text-xl sm:text-2xl md:text-3xl lg:text-4xl mb-2 sm:mb-2 md:mb-6">WatchList</div>
          <div>
            <WatchListTable tableData={watchListTableData} isWatchList={true} />
          </div>
          <div className="footer">
            <Link to="/all-companies" className="text-[#40A9FF] watch-list-table-data hover:text-[#40A9FF] hover:underline text-xs sm:text-sm md:text-base lg:text-lg">View all followed companies</Link>
          </div>
        </div>
        <div className="most-valuable-companies-container mb-5 sm:mb-5 md:mb-10">
          <div className="font-bold text-xl sm:text-2xl md:text-3xl lg:text-4xl mb-2 sm:mb-2 md:mb-6">Most Valuable Companies</div>
          <div>
            {mostValuableCompaniesLoading ? (
                <div className="text-center py-8">
                  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto"></div>
                </div>
            ) : error ? (
                <div className="bg-red-900/50 text-red-200 p-4 rounded-xl">
                  {error}
                </div>
            ) : (
                <MostValuableCompanyTable tableData={mostValuableCompanies} />
            )}
          </div>
          <div className="footer">
            <Link to="/all-companies" className="text-[#40A9FF] watch-list-table-data hover:text-[#40A9FF] hover:underline text-xs sm:text-sm md:text-base lg:text-lg">View all companies</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
